<template>
    <div class="search">
       <div class="banner">
                <el-carousel height="330px" arrow="always" >
                    <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                        <img @click="toProductdetail(item.category,item.productName)" :src="item.picUrl"/>
                    </el-carousel-item>
                </el-carousel>
        </div>
        <div class="head_title">
            <div class="local">
                <p v-if="languageType == 0">当前位置：首页 > 站内搜索</p>
                <p v-else>Location: Home > Station Search</p>
            </div>
        </div>
        <div class="content">
            <div class="no_result" v-if="Isresult">
                <div class="bg"></div>
                <p v-if="languageType == 0">搜索不到您要的结果，换个关键词试试哦</p>
                <p v-else>You can't find the result you want. Try another keyword</p>
            </div>
            <div class="result" v-else>
                <div class="total">
                    <span v-if="languageType == 0">为您找到相关结果 {{total}} 个</span>
                    <span v-else>{{total}} results for you</span>
                    </div>
                <div class="product_list">
                    <div class="title">
                        <span>{{languageType == 0?'相关产品':'Related products'}}</span>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item,index) in productList" :key="index" @click="toProductdetail(item.categoryId,item.name)">
                                <div class="picter">
                                    <img :src="item.picUrl"/>
                                </div>
                                <div class="text">
                                    <p>{{ languageType == 0?item.name:item.enName }}</p>
                                    <span>{{ languageType == 0?item.detail:item.enDetail }}</span>
                                </div>
                            </li>
                            <div class="clear"></div>
                        </ul>
                    </div>
                </div>
                <div class="news_list">
                    <div class="title">
                        <span>{{languageType == 0?'相关新闻':'Related news'}}</span>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item,index) in newsList" :key="index" @click="toNews(item)">
                                <div class="picture">
                                    <img :src="item.pic"/>
                                </div>
                                <div class="main">
                                    <div class="title">
                                        <a>{{ languageType == 0?item.name:item.enName}}</a>
                                    </div>
                                    <p>{{ languageType == 0?item.detail:item.enDetail }}</p>
                                    <span>{{ item.addTime | filteraddTime }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['languageType'],
    data () {
        return {
            total:0,
            Isresult:false,
            bannerList:[],
            productList:[
            ],
            newsList:[
            ],
        }
    },
    created () {
        const key =this.$route.query.key? JSON.parse(this.$route.query.key):this.$route.query.key
        this.getBannerList()
        this.getSearchList(key)
    },
    filters:{
        filteraddTime (val) {
            const time = String(val).slice(0,10)
            return time
        }
    },
    methods:{
         getBannerList () {
            this.$http({
                url: this.$http.adornUrl('/web/banner/list'),
                method: 'post',
                data: {
                    'page': '1',
                    'limit': '999',
                    'type':2,
                    'productId': "",
                    'client': ""
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    this.bannerList = data.page.list.slice(0,3)
                } else {
                    this.bannerList = []
                }
            })
        },
        getSearchList (key) {
            this.$http({
                url: this.$http.adornUrl('/web/product/search'),
                method: 'post',
                params: {
                    'key':key
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                  this.newsList = data.data.news
                  this.productList = data.data.products.slice(0,3)
                  this.total = (data.data.news.length) + (data.data.products.length)
                } else {
                    
                }
            })
        },
        toProductdetail (id,name) {
            this.$router.push({ name: 'productdetail',query:{key:JSON.stringify(name),id:JSON.stringify(id)}}),
            this.$emit('changeIndex',5)
        },
        toNews (item) {
            sessionStorage.setItem('detail',JSON.stringify(item))
            this.$router.push({ name:'newsdetail'})
            this.$emit('changeIndex',1)
        },
        toProductdetail (id,name) {
            this.$router.push({ name: 'productdetail',query:{key:JSON.stringify(name),id:JSON.stringify(id)}})

        }
    }
}
</script>

<style lang="less" scoped>
    .search {
        .banner {
            img {
                height: 330px;
            }
        }
        .head_title {
            width: 1170px;
            margin: 0 auto;
            overflow: hidden;
            height: 76px;
            .local {
                float: right;
                p {
                    color: #606060;
                    font-size: 16px;
                    margin: 31px 0;
                }
            }
        }
        .content {
            // height: 650px;
            position: relative;
            background-color: #f4f4f4;
            overflow: hidden;
            .no_result {
                width: 1317px;
                height: 539px;
                border-top: 1px solid #ffffff;
                background-color: #ffffff;
                margin: 20px auto 90px auto;
                position: relative;
                z-index: 999;
                .bg {
                    width: 206px;
                    height: 206px;
                    background: url(../../static/img/search_bg.png)no-repeat center center;
                    margin: 0 auto;
                    margin-top: 126px;
                }
                p {
                    font-size: 20px;
                    color: #bdbdbd;
                    margin-top: 20px;
                }
            }
            .result {
                 width: 1317px;
                 margin: 15px auto 50px auto;
                .total {
                    position: relative;
                    text-align: left;
                    span {
                        font-size: 18px;
                        color: #838383;
                        border-bottom: 1px solid #bbbbbb;
                    }
                    &::after {
                        // content: '';
                        display: block;
                        position: absolute;
                        height: 1px;
                        width: 185px;
                        background-color: #bbbbbb;
                        left: 0;
                        bottom: 0;
                    }
                }
                .product_list {
                    margin: 30px 0;
                    .title {
                        width: 185px;
                        padding-bottom: 10px;
                        text-align: left;
                        border-bottom: 1px solid #bbbbbb;
                        span {
                            font-size: 24px;
                            color: #838383;
                        }
                    }
                    .list {
                        margin-top: 15px;
                        cursor: pointer;
                        ul {
                            li {
                                width: 432px;
                                height: 344px;
                                float: left;
                                background-color: #fff;
                                box-shadow:-3px 0 5px rgba(222, 222, 222, 0.8),3px 0 5px rgba(222, 222, 222, 0.8),
                                0 -3px 5px rgba(222, 222, 222, 0.8), 0 3px 5px rgba(222, 222, 222, 0.8);
                                position: relative;
                                margin-right: 10px;
                                .picter {
                                    transform: scale(0.9);
                                    img {
                                        width: 432px;
                                        height: 241px;
                                    }
                                }
                                .text {
                                    width: 432px;
                                    height: 103px;
                                    position: relative;
                                    text-align: left;
                                    &:hover {
                                        p {
                                            color: #e21711;
                                        }
                                        span {
                                             color: #e21711;
                                        }
                                    }
                                    p {
                                        font-size: 24px;
                                        color: #000000;
                                        padding: 18px 0 0 20px;
                                    }
                                    span {
                                        font-size: 16px;
                                        color: #606060;
                                        margin: 2px 0 0px 20px;
                                        display: -webkit-box;
                                        -webkit-box-orient: vertical;
                                        -webkit-line-clamp: 2;
                                        overflow: hidden;
                                    }
                                }
                                .text::before {
                                    content: '';
                                    display: block;
                                    position: absolute;
                                    top: 0;
                                    left: 1px;
                                    width: 430px;
                                    height: 1px;
                                    background-color: #d6d6d6;
                                }
                            }
                            li::after {
                            content: '';
                                display: block;
                                position: absolute;
                                left: 0;
                                bottom: 0;
                                width: 100%;
                                height: 9px;
                                background-color: #e21711;
                            }
                            :nth-child(3) {
                                margin-right: 0;
                            }
                            .clear {
                                clear: both;
                                float:none;
                                
                            }
                        }
                    }
                }
                .news_list {
                    margin: 30px 0;
                    >.title {
                        width: 185px;
                        padding-bottom: 10px;
                        text-align: left;
                        border-bottom: 1px solid #bbbbbb;
                        span {
                            font-size: 24px;
                            color: #838383;
                        }
                    }
                    .list {
                        margin-top: 15px;
                        background-color: #ffffff;
                        max-height: 956px;
                        overflow-x: hidden;
                        overflow-y: scroll; 
                        ul {
                            margin: 0px 60px 0px 60px;
                            padding-top: 35px;
                            padding-bottom: 50px;
                            li {
                                height: 173px;
                                border-bottom: 1px solid #e2e0e0;
                                overflow: hidden;
                                cursor: pointer;
                                &:first-child {
                                    border-top: 1px solid #e2e0e0;
                                }
                                .picture {
                                    margin-top: 27px;
                                    float: left;
                                    img {
                                        width: 217px;
                                        height: 120px;
                                    }
                                }
                                .main {
                                    width: 823px;
                                    float: left;
                                    margin-top: 27px;
                                    margin-left: 20px;
                                    .title {
                                        &:hover {
                                            a {
                                                color: #e21711;
                                            }
                                        }
                                        text-align: left;
                                        a {
                                            font-size: 25px;
                                            color: #000000;
                                        }
                                    }
                                    p {
                                        text-align: left;
                                        font-size: 16px;
                                        color: #606060;
                                        line-height: 25px;
                                        min-height: 50px;
                                        overflow: hidden;
                                        margin-top: 12px;
                                        margin-bottom: 12px;
                                    }
                                    span {
                                        display: block;
                                        text-align: left;
                                        font-size: 16px;
                                        color: #606060;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .content::before {
            content: '';
            display: block;
            position: absolute;
            top: -180px;
            left: -440px;
            width: 980px;
            height: 678px;
            background: url(../../static/img/long.png)no-repeat center center;
            transform: scale(0.8)
        }
        .content::after {
            content: '';
            display: block;
            position: absolute;
            right: -275px;
            bottom: -160px;
            width: 980px;
            height: 678px;
            background: url(../../static/img/tu.png)no-repeat center center;
            transform: scale(0.8)
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/search.vue